export enum EGeoTypes {
  region = 'region',
  street = 'street',
}
